import React from "react";
import LocalSalesRep from "./local-sales-rep.jsx";
import IntlMap from "./intl-map.jsx";
import LoaderSection from "../loader.jsx";
import DistrictRep from "./district-rep.jsx";

const InternationalState = props => {
    let loader, error, salesRep, finalReps, equipmentReps, distHeading, dealerHeading;
    let dealerClass = "";
    let count = 1;
    let distCount = 1;
    if (props.state.loading) loader = <LoaderSection show={true} />;

    const countryList = props.state.countries.map((item, index) => (
        <option id={item.countryId} className="country-select" key={index} value={item.countryId}>
            {item.countryName}
        </option>
    ));

    if (
        !props.state.firstLoad &&
        !props.state.loading &&
        !props.state.dealers.length &&
        !props.state.salesReps.length &&
        props.state.country !== ""

    ) {
        error = (
            <div className="dealer-error">
                <p className="error">{props.state.errorMsg}</p>
                <a className="btn btn-outline" href="/support/customer-service">
                    {props.state.errorBtn}
                </a>
            </div>
        );
    }

    if (props.state.salesReps.filter(r => !r.IsESM).length) {
        dealerClass = "col-lg-8";

        salesRep = props.state.salesReps.filter(r => !r.IsESM).map((item, index) =>
            <DistrictRep key={index} {...item} onVideoClick={props.onVideoClick} index={index}/>
        );

        finalReps = (
            <div className="col-lg-4">
                <div className="dealer-header-wrapper">
                    <p className="local-dealer-header">
                        <span>Available Contacts</span>
                    </p>
                </div>
                <div className="sales-rep-container">
                    {salesRep}
                </div>
            </div>
        );
    }

    if (props.state.salesReps.filter(r => r.IsESM).length) {
        dealerClass = "col-lg-8";

        const reps = props.state.salesReps.filter(r => r.IsESM).map((item, index) =>
            <DistrictRep key={index + props.state.salesReps.filter(r => r.IsDSM).length} {...item} onVideoClick={props.onVideoClick} index={index + props.state.salesReps.filter(r => r.IsDSM).length}/>
        );

        equipmentReps = (
            <div className="col-lg-4">
                <div className="dealer-header-wrapper">
                    <p className="local-dealer-header">
                        <span>Equipment Sales Representatives</span>
                    </p>
                </div>
                <div className="sales-rep-container">
                    {reps}
                </div>
            </div>
        );
    }

    const dealers = props.state.dealers.filter(d => !d.isDistributor).map((item) => (
        <LocalSalesRep
            id={count++}
            account={item}
        />
    ));

    if (props.state.useDistributors) {
        distHeading = (
            <div className="dealer-header-wrapper">
                <p className="local-dealer-header">
                    <span>Distributors</span>
                </p>
            </div>
        );
    }

    if (dealers.length > 0) {
        dealerHeading = (
            <div className="dealer-header-wrapper">
                <p className="local-dealer-header">
                    <span>Dealers</span>
                </p>
            </div>
        );
    }

    const distributors = props.state.dealers.filter(d => d.isDistributor).length > 0 && !props.state.firstLoad && !props.state.loading
        ? props.state.dealers.filter(d => d.isDistributor).map((item) => (
            <LocalSalesRep
                id={distCount++}
                account={item}
            />
        ))
        : <div className="col-lg-12">
              <p className="error">Distributor not available in this area.
              </p>
          </div>;

    const distributorArea = !props.state.firstLoad && !props.state.loading && props.state.useDistributors ?
        <React.Fragment>
            <div className="col-lg-8">
                {distHeading}
                <div className={`dealer-col`}>{distributors}</div>
            </div>

            {equipmentReps}

        </React.Fragment>
        : <React.Fragment></React.Fragment>;

    return (
        <div>
            <div className="country-dropdown">
                <div className="map-search-box filter-dropdown col-lg-6">
                    <label className="sr-only" htmlFor="country">
                        Pick A Country
                    </label>
                    <select
                        className="form-control"
                        id="country"
                        name="country"
                        onChange={props.onChangeCountry}
                        value={props.state.country}
                    >
                        <option selected disabled hidden>
                            Choose a country...
                        </option>
                        {countryList}
                    </select>
                </div>
            </div>
            <div className="intl-loader">{loader}</div>
            {error}
            <div>
                <IntlMap
                    center={props.state.center}
                    zoom={props.state.zoom}
                    lat={props.state.lat}
                    lng={props.state.lng}
                    markers={props.state.dealers.filter(d => !d.isDistributor)}
                    distPins={props.state.dealers.filter(d => d.isDistributor)}
                    currentCategory={props.categoryCompare}
                    distance={props.state.distance}
                    userLat={props.state.userLat}
                    userLng={props.state.userLng}
                    onChange={props.onLinkChange}
                    eventTarget={props.state.eventTarget}
                    firstLoad={props.state.firstLoad}
                    prevLat={props.state.prevLat}
                    prevLng={props.state.prevLng}
                    _onChange={props._onChange}
                    searchType={props.state.searchType}
                    country={props.state.country}
                />
            </div>
            <div className="row dealer-info-row">
                {distributorArea}
               
                <div className="col-lg-8">
                    {dealerHeading}
                    <div className={`dealer-col`}>{dealers}</div>
                </div>
                {finalReps}
            </div>
        </div>
    );
};

export default InternationalState;
